var _a;
import { UnitSuffix } from '../../defs';
import { INCH_PIXEL_VALUE } from '../../internal/constants';
import { noConvert } from '../../internal/converters';
import { pixel } from '../../internal/converters/pixel';
var inchToPixel = function (value) {
    return value * INCH_PIXEL_VALUE;
};
var inchToCentimeter = function (value) {
    return pixel.cm(inchToPixel(value));
};
var inchToMillimeter = function (value) {
    return pixel.mm(inchToPixel(value));
};
var inchToQuarter = function (value) {
    return pixel.Q(inchToPixel(value));
};
var inchToPica = function (value) {
    return pixel.pc(inchToPixel(value));
};
var inchToPoint = function (value) {
    return pixel.pt(inchToPixel(value));
};
var inchToREM = function (value, options) {
    return pixel.rem(inchToPixel(value), options);
};
var inchToEM = function (value, options) {
    return pixel.em(inchToPixel(value), options);
};
var inchToViewWidth = function (value, options) {
    return pixel.vw(inchToPixel(value), options);
};
var inchToViewHeight = function (value, options) {
    return pixel.vh(inchToPixel(value), options);
};
var inchToViewMin = function (value, options) {
    return pixel.vmin(inchToPixel(value), options);
};
var inchToViewMax = function (value, options) {
    return pixel.vmax(inchToPixel(value), options);
};
export var inch = (_a = {},
    _a[UnitSuffix.Pixel] = inchToPixel,
    _a[UnitSuffix.Centimeter] = inchToCentimeter,
    _a[UnitSuffix.Millimeter] = inchToMillimeter,
    _a[UnitSuffix.Quarter] = inchToQuarter,
    _a[UnitSuffix.Inch] = noConvert,
    _a[UnitSuffix.Pica] = inchToPica,
    _a[UnitSuffix.Point] = inchToPoint,
    _a[UnitSuffix.REM] = inchToREM,
    _a[UnitSuffix.EM] = inchToEM,
    _a[UnitSuffix.ViewWidth] = inchToViewWidth,
    _a[UnitSuffix.ViewHeight] = inchToViewHeight,
    _a[UnitSuffix.ViewMin] = inchToViewMin,
    _a[UnitSuffix.ViewMax] = inchToViewMax,
    _a);
//# sourceMappingURL=inch.js.map